<ng-container *transloco="let t">
  @if (insurancesOptions$ | async; as insuranceOptions) {
    @if (insuranceOptions.length) {
      @if (showLabel) {
        <span class="fixed-space-24" aria-hidden="true"></span>
        <div class="flex align-center">
          <popsy-icon-popsy-shield-4 class="icon kafala"></popsy-icon-popsy-shield-4>
          <h2 class="label text-gray-05">{{ t('label_popsy_kafala') }}</h2>
          <span class="fixed-space-4" aria-hidden="true"></span>
          <button (click)="onShowConditionInfo()" class="popsy-button-icon info">
            <popsy-icon-information-circle
              class="icon gray-dark"></popsy-icon-information-circle>
          </button>
        </div>
      } @else {
        <span class="fixed-space-12" aria-hidden="true"></span>
      }
      @if (insuranceOptions) {
        <nav
          class="product-insurance-options-component"
          [class.mobile]="(biggerThan$ | async)?.xs"
          [class.widescreen]="(biggerThan$ | async)?.mobileL">
          <ul class="flex flex-row variant-list">
            <!-- FAIR Condition -->
            @for (
              insurance of insuranceOptions;
              track trackByInsurance(i, insurance);
              let i = $index
            ) {
              <li class="flex flex-col variant-card" [class.selected]="">
                <div
                  class="insurance"
                  [class.selected]="isInsuranceSelected(insurance)"
                  (click)="
                    onInsuranceSelected(!isInsuranceSelected(insurance), insurance)
                  ">
                  @if (i === 0 && insuranceOptions.length === 1) {
                    <div class="pill">
                      <span>{{ t('label_recommended') }}</span>
                    </div>
                  }
                  @if (i > 0 && i === insuranceOptions.length - 1) {
                    <div class="pill red">
                      <span>{{ t('label_best_value') }}</span>
                    </div>
                  }
                  <div class="flex align-center full-width">
                    <popsy-checkbox
                      class="insurance-checkbox"
                      [text]=""
                      [optionText]=""
                      [boldLabel]="true"
                      [focus]="isInsuranceSelected(insurance)"
                      [checked]="isInsuranceSelected(insurance)"></popsy-checkbox>
                    <strong>{{ insurance?.description }}</strong>
                    <button
                      class="popsy-button-icon expand"
                      (click)="onExpandInsurance($event, i)">
                      <popsy-icon-chevron-down
                        class="icon fill-gray-01"
                        [class.selected]="insuranceExpanded[i]" />
                    </button>
                    <span class="dynamic-space" aria-label="aria-hidden"></span>
                    <strong class="text-highlight">{{
                      insurance?.price | amount
                    }}</strong>
                    <span class="fixed-space-8" aria-hidden="true"></span>
                  </div>
                  @if (insuranceExpanded[i]) {
                    <span class="fixed-space-8" aria-hidden="true"></span>
                    <div class="spec-cont flex">
                      <span class="fixed-space-24" aria-hidden="true"></span>
                      @if (language !== 'ar') {
                        <div class="specs flex flex-col">
                          <div class="flex align-start">
                            <popsy-icon-check-1 class="icon gray-01"></popsy-icon-check-1>
                            <span class="fixed-space-8" aria-hidden="true"></span>
                            <span>Comprehensive Protection</span>
                          </div>
                          <span class="fixed-space-8" aria-hidden="true"></span>
                          <div class="flex align-start">
                            <popsy-icon-check-1 class="icon gray-01"></popsy-icon-check-1>
                            <span class="fixed-space-8" aria-hidden="true"></span>
                            <span
                              >Coverage for defects, malfunctions, and accidental
                              damage</span
                            >
                          </div>
                          <span class="fixed-space-8" aria-hidden="true"></span>
                          <div class="flex align-start">
                            <popsy-icon-check-1 class="icon gray-01"></popsy-icon-check-1>
                            <span class="fixed-space-8" aria-hidden="true"></span>
                            <span>Battery and Screen Replacement</span>
                          </div>
                          <span class="fixed-space-8" aria-hidden="true"></span>
                          <div class="flex align-start">
                            <popsy-icon-check-1 class="icon gray-01"></popsy-icon-check-1>
                            <span class="fixed-space-8" aria-hidden="true"></span>
                            <span>Fast and Easy Claims Process</span>
                          </div>
                          <span class="fixed-space-8" aria-hidden="true"></span>
                          <div class="flex align-start">
                            <popsy-icon-check-1 class="icon gray-01"></popsy-icon-check-1>
                            <span class="fixed-space-8" aria-hidden="true"></span>
                            <span>Replacement Assurance</span>
                          </div>
                        </div>
                      }
                      @if (language === 'ar') {
                        <div class="specs flex flex-col">
                          <div class="flex align-start">
                            <popsy-icon-check-1 class="icon gray-01"></popsy-icon-check-1>
                            <span class="fixed-space-8" aria-hidden="true"></span>
                            <span>حماية شاملة لمدة 24 شهراً</span>
                          </div>
                          <span class="fixed-space-8" aria-hidden="true"></span>
                          <div class="flex align-start">
                            <popsy-icon-check-1 class="icon gray-01"></popsy-icon-check-1>
                            <span class="fixed-space-8" aria-hidden="true"></span>
                            <span
                              >تغطية كاملة للعيوب والأعطال والأضرار العرضية التي قد تطال
                              الجهاز</span
                            >
                          </div>
                          <span class="fixed-space-8" aria-hidden="true"></span>
                          <div class="flex align-start">
                            <popsy-icon-check-1 class="icon gray-01"></popsy-icon-check-1>
                            <span class="fixed-space-8" aria-hidden="true"></span>
                            <span>استبدال للبطارية والشاشة</span>
                          </div>
                          <span class="fixed-space-8" aria-hidden="true"></span>
                          <div class="flex align-start">
                            <popsy-icon-check-1 class="icon gray-01"></popsy-icon-check-1>
                            <span class="fixed-space-8" aria-hidden="true"></span>
                            <span>إجراءات مطالبة سهلة وسريعة</span>
                          </div>
                          <span class="fixed-space-8" aria-hidden="true"></span>
                          <div class="flex align-start">
                            <popsy-icon-check-1 class="icon gray-01"></popsy-icon-check-1>
                            <span class="fixed-space-8" aria-hidden="true"></span>
                            <span>ضمان عملية الاستيدال </span>
                          </div>
                        </div>
                      }
                    </div>
                    <span class="fixed-space-8" aria-hidden="true"></span>
                  }
                </div>
              </li>
            }
          </ul>
        </nav>
      }
    }
  } @else if (
    !(insurancesOptions$ | async)?.length &&
    (findingInsurances$ | async) === true &&
    showLabel
  ) {
    <popsy-skeleton
      class="product-insurance-options-component skeleton"
      [class.mobile]="(biggerThan$ | async)?.xs"
      [class.widescreen]="(biggerThan$ | async)?.mobileL"></popsy-skeleton>
  }
</ng-container>
